var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.33301C6.75 0.918794 6.41421 0.583008 6 0.583008C5.58579 0.583008 5.25 0.918794 5.25 1.33301V8.85609L1.86334 5.46943C1.57044 5.17653 1.09557 5.17653 0.802678 5.46943C0.509785 5.76232 0.509785 6.23719 0.802678 6.53009L5.46934 11.1968C5.63824 11.3657 5.86766 11.4372 6.0878 11.4113C6.26546 11.3905 6.42416 11.3077 6.54164 11.1851L11.1967 6.53009C11.4896 6.23719 11.4896 5.76232 11.1967 5.46943C10.9038 5.17653 10.4289 5.17653 10.136 5.46943L6.75 8.85544V1.33301Z",
    fill: "#CC000A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.ae97c2a8ac6fbed0b1e8c9847848d7b2.svg";
export { ForwardRef as ReactComponent };